module.exports = __webpack_public_path__ + "img/01.a3f9bddf.gif";